/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface CreateTuitionRateTierRequest
 */
export interface CreateTuitionRateTierRequest {
    /**
     * 
     * @type {number}
     * @memberof CreateTuitionRateTierRequest
     */
    minQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTuitionRateTierRequest
     */
    maxQuantity: number;
    /**
     * 
     * @type {number}
     * @memberof CreateTuitionRateTierRequest
     */
    amount: number;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof CreateTuitionRateTierRequest
     */
    sortOrder: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the CreateTuitionRateTierRequest interface.
 */
export function instanceOfCreateTuitionRateTierRequest(value: object): value is CreateTuitionRateTierRequest {
    if (!('minQuantity' in value) || value['minQuantity'] === undefined) return false;
    if (!('maxQuantity' in value) || value['maxQuantity'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('sortOrder' in value) || value['sortOrder'] === undefined) return false;
    return true;
}

export function CreateTuitionRateTierRequestFromJSON(json: any): CreateTuitionRateTierRequest {
    return CreateTuitionRateTierRequestFromJSONTyped(json, false);
}

export function CreateTuitionRateTierRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTuitionRateTierRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'minQuantity': json['minQuantity'],
        'maxQuantity': json['maxQuantity'],
        'amount': json['amount'],
        'sortOrder': ApiUserTasksGetPageParameterFromJSON(json['sortOrder']),
    };
}

export function CreateTuitionRateTierRequestToJSON(json: any): CreateTuitionRateTierRequest {
    return CreateTuitionRateTierRequestToJSONTyped(json, false);
}

export function CreateTuitionRateTierRequestToJSONTyped(value?: CreateTuitionRateTierRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'minQuantity': value['minQuantity'],
        'maxQuantity': value['maxQuantity'],
        'amount': value['amount'],
        'sortOrder': ApiUserTasksGetPageParameterToJSON(value['sortOrder']),
    };
}

